<template>
  <v-card style="overflow: hidden;">
    <v-toolbar flat dense color="secondary" dark>
      <v-toolbar-title class="body-2">{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn-toggle
        v-if="dateRangeEditable"
        v-model="selectedDateRange"
        mandatory
        class="date-range-toggle"
      >
        <v-btn
          v-for="(item, idx) in dateRangeShortcuts"
          :key="idx"
          flat
          small
          :value="item.value"
          :title="item.label"
          class="text-capitalize"
        >
          {{ item.shortLabel }}
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <v-layout wrap class="pa-2">
      <v-flex
        v-for="(child, idx) in children"
        :key="idx"
        v-bind="childFlexProps"
        class="pa-2"
      >
        <TimeSeriesGraphWidget
          ref="childWidgets"
          :widget-id="`${widgetId}-${idx}`"
          :config="child"
          :global-date-range="selectedDateRange"
        />
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import TimeSeriesGraphWidget from './TimeSeriesGraphWidget'
import { dateRangeShortcuts } from './dateRange'

export default {
  name: 'TimeSeriesGraphGroupWidget',
  components: {
    TimeSeriesGraphWidget,
  },
  props: {
    widgetId: { type: String, required: true },
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      selectedDateRange: this.config.dateRange || 'pastTwoWeeks',
    }
  },
  computed: {
    title() {
      return this.config.title || 'Time Series Graphs'
    },
    dateRangeEditable() {
      return this.config.dateRangeEditable !== false
    },
    dateRangeShortcuts() {
      return dateRangeShortcuts
    },
    children() {
      return this.config.widgets || []
    },
    childWidth() {
      return Math.floor(12 / (this.config.columns || 3))
    },
    childFlexProps() {
      return {
        xs12: true,
        [`md${this.childWidth}`]: true,
        [`lg${this.childWidth}`]: true,
      }
    },
  },
  methods: {
    async initialize(force = false) {
      const children = this.$refs.childWidgets || []
      await Promise.allSettled(children.map(w => w.initialize(force)))
    },
  },
}
</script>

<style scoped>
.date-range-toggle {
  margin-right: 8px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 4px;
}
</style>
